export const ABOUT_INFO = {
  brandName: '777影院',
  tagline: '777影院午夜伦不卡 — 电影电视剧全集在线观看高清不缓冲',
  founded: '2018',
  description: '777影院成立于2018年，是国内领先的在线影视播放平台。我们致力于为用户提供丰富、高清、流畅的影视内容观看体验。平台汇聚了海量电影、电视剧、综艺、动漫、纪录片等正版高清资源，支持多端同步观看。\n\n777影院始终坚持"用户至上"的理念，不断优化播放技术和内容储备。我们采用先进的CDN加速技术和智能码率自适应方案，确保用户在任何网络环境下都能获得极致流畅的观影体验。\n\n目前，777影院已累计服务超过5000万用户，月活跃用户突破2000万，日均播放量超过1亿次。在第三方用户满意度调查中，连续三年获得"最佳用户体验"奖项。\n\n我们的使命是让每一个人都能随时随地享受高品质的影视内容。从经典老片到最新热播，从国产佳作到海外精选，777影院始终是你观影的最佳选择。',
  stats: [
    { value: '5000万+', label: '累计用户' },
    { value: '10万+', label: '影视资源' },
    { value: '99.9%', label: '播放成功率' },
    { value: '4.9/5', label: '用户评分' },
  ],
  features: [
    { title: '高清画质', description: '支持1080P/4K超清画质，智能码率自适应，享受影院级视觉体验。', icon: 'ri-4k-line' },
    { title: '极速播放', description: '全球CDN加速节点，秒级缓冲启动，告别卡顿和等待。', icon: 'ri-speed-up-line' },
    { title: '海量资源', description: '10万+影视资源持续更新，覆盖电影、电视剧、综艺、动漫等全品类。', icon: 'ri-database-2-line' },
    { title: '多端同步', description: '支持手机、平板、电脑、电视全终端，观影记录云端同步。', icon: 'ri-device-line' },
    { title: '无广告', description: '纯净观影体验，全程无广告打扰，让你沉浸在剧情之中。', icon: 'ri-advertisement-line' },
    { title: '智能推荐', description: '基于AI算法的个性化推荐，帮你发现更多喜欢的影视内容。', icon: 'ri-brain-line' },
  ],
};

export const TESTIMONIALS = [
  {
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%2C%20professional%20headshot%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20warm%20lighting&width=100&height=100&seq=avatar-1&orientation=squarish',
    rating: 5,
    comment: '用了777影院三年了，画质和流畅度一直是行业中最好的。更新速度也很快，新上映的电影很快就能看到高清版本。',
    date: '2026-07-15',
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20professional%20headshot%2C%20gentle%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting&width=100&height=100&seq=avatar-2&orientation=squarish',
    rating: 5,
    comment: '作为一个追剧达人，777影院是我的首选。资源全、更新快、播放流畅，还支持离线缓存，地铁上也能看。',
    date: '2026-07-10',
  },
  {
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%2C%20casual%20headshot%2C%20bright%20smile%2C%20clean%20studio%20background%2C%20natural%20lighting&width=100&height=100&seq=avatar-3&orientation=squarish',
    rating: 5,
    comment: '强烈推荐！4K画质真的惊艳，而且没有任何广告。和室友一起用投影仪看大片，体验感拉满。',
    date: '2026-06-28',
  },
  {
    name: '赵阿姨',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20woman%20portrait%2C%20warm%20headshot%2C%20kind%20smile%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=100&height=100&seq=avatar-4&orientation=squarish',
    rating: 5,
    comment: '儿子教我用777影院看电视剧，操作很简单，老年人也能轻松使用。资源很多，每天都有新剧更新。',
    date: '2026-06-20',
  },
];

export const FAQ_DATA = [
  {
    question: '777影院需要注册会员才能观看吗？',
    answer: '777影院提供免费观看服务。部分最新热播内容需要注册免费会员后观看，注册过程简单快捷，只需手机号验证即可完成。会员还可以享受高清画质、离线缓存、观影记录同步等专属权益。',
  },
  {
    question: '777影院支持哪些设备观看？',
    answer: '777影院支持全终端观看，包括：手机（iOS/Android）、平板（iPad/安卓平板）、电脑（Windows/Mac浏览器）、智能电视和投影仪。您可以在不同设备间无缝切换，观影记录自动同步。',
  },
  {
    question: '为什么有时候播放会卡顿？',
    answer: '如果您遇到播放卡顿的情况，可以尝试以下方法：1）切换播放线路（播放器右下角可以选择备用线路）；2）降低画质档位（从4K切换至1080P或720P）；3）检查您的网络连接是否稳定。777影院采用智能码率自适应技术，会自动根据您的网络状况调整画质。',
  },
  {
    question: '777影院的内容更新频率是怎样的？',
    answer: '我们每天24小时不间断更新内容。电影一般在院线下映后1-2周内上线；国产电视剧每日同步更新；综艺节目播出后2小时内上线；动漫每周按番剧播出节奏更新。您可以在首页"最新更新"区域查看当天新上线的所有内容。',
  },
  {
    question: '如何联系777影院客服？',
    answer: '您可以通过以下方式联系我们的客服团队：1）在线客服：网站右下角点击客服图标即可实时沟通（服务时间：9:00-24:00）；2）邮箱：service@777cinema.com；3）微信公众号：搜索"777影院"关注后发送消息。我们会在24小时内回复您的咨询。',
  },
];

export const CONTACT_INFO = {
  email: 'service@777cinema.com',
  wechat: '777影院',
  weibo: '@777影院官方',
  phone: '400-777-8888',
  address: '北京市朝阳区望京SOHO T3 18层',
  workingHours: '周一至周日 9:00 - 24:00',
};